import React from "react";
import styled from "styled-components";
import StoreButtons from "../components/StoreButtons";
import NotifyForm from "../components/NotifyForm";
import Threads from "../components/Threads";

const Section = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 7rem 2rem 6rem;
  margin-top: 2rem;
  /* same black as the footer so both read as one block */
  background: #000;
  color: var(--text-inv);
  overflow: hidden;

  @media screen and (max-width: 48em) {
    padding: 5rem 1.5rem 4rem;
  }
`;

// Brand wave, static and very discreet
const Wave = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.16;
  pointer-events: none;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 44rem;
`;

const Title = styled.h2`
  font-family: var(--fontL);
  font-weight: 500;
  font-size: clamp(2.5rem, 6vw, 4.25rem);
  line-height: 1.05;
  letter-spacing: -0.03em;
  margin-bottom: 1.25rem;
`;

const Subtitle = styled.p`
  font-family: var(--fontR);
  font-size: 1.0625rem;
  line-height: 1.6;
  color: #b4b4ba;
  margin-bottom: 2.25rem;
`;

const Android = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.875rem;
  width: 100%;
  margin-top: 3.5rem;
  padding-top: 2.5rem;
  border-top: 1px solid var(--ink-700);

  p {
    font-family: var(--fontR);
    font-size: 0.9375rem;
    color: #b4b4ba;
  }
`;

const FinalCta = () => (
  <Section>
    <Wave>
      <Threads color={[1, 1, 1]} />
    </Wave>
    <Content data-reveal>
      <Title>
        Ton argent,
        <br />
        enfin sous contrôle.
      </Title>
      <Subtitle>Connecte tes comptes et vois ce que ça donne. C'est gratuit, et ça prend trois minutes.</Subtitle>
      <StoreButtons tone="dark" position="cta-final" center />

      <Android id="android">
        <p>Tu es sur Android ? Laisse ton email, on te prévient le jour de la sortie.</p>
        <NotifyForm />
      </Android>
    </Content>
  </Section>
);

export default FinalCta;
